module.exports = __webpack_public_path__ + "img/svip2x.9b00155f.png";